import React from 'react';
import { injectIntl } from 'react-intl';
import Helmet from 'react-helmet';
import { getAppMetadata } from '../../constants/metadata';

export default injectIntl(({ intl: { formatMessage } }) => (
  <Helmet {...{ ...getAppMetadata(formatMessage) }} />
));



// WEBPACK FOOTER //
// ./src/components/AppHelmet/index.jsx